import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "7f34439d-d87b-413f-a300-1a3e1c48dd27",
  publicId: "30",
  name: "Horns",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01],
};

export default lesson;
